import { render, staticRenderFns } from "./NewExtensionListTable.vue?vue&type=template&id=7ef23456&scoped=true&lang=pug&"
import script from "./NewExtensionListTable.vue?vue&type=script&lang=ts&"
export * from "./NewExtensionListTable.vue?vue&type=script&lang=ts&"
import style0 from "./NewExtensionListTable.vue?vue&type=style&index=0&id=7ef23456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef23456",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
